<template>
  <v-card elevation="3" class="marketing-wrapper-right light-grey-background">
    <div class="gallery-wrapper">
      <h2 class="h2-header">PortalBuilder Galerie</h2>
      <v-row dense justify="center">
        <v-col cols="12" sm="8" md="6" v-if="previews.length > 0">
          <v-card>
            <v-img
              :src="getPreviewUrl(previews[currentIndex].s3key)"
              alt="Preview Image"
              class="preview-image"
              @click="openFullscreenDialog"
            ></v-img>
            <v-card-text>
              <p>
                <strong>Agentur:</strong>
                {{ previews[currentIndex].companyName }}
              </p>
            </v-card-text>
          </v-card>
          <div class="navigation-buttons">
            <v-btn
              @click="prevImage"
              :disabled="currentIndex === 0"
              icon="mdi-arrow-left"
            ></v-btn>
            <v-btn
              @click="nextImage"
              :disabled="currentIndex === previews.length - 1"
              icon="mdi-arrow-right"
            ></v-btn>
          </div>
          <div>
            <v-btn
              @click="openAgencyDialog(previews[currentIndex])"
              class="gradient-color-primary"
              rounded="lg"
            >
              Zur Agentur
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" sm="8" md="6" v-else>
          <p>Loading previews...</p>
        </v-col>
      </v-row>

      <v-dialog v-model="fullscreenDialog" max-width="90%">
        <v-card>
          <v-img
            v-if="previews.length > 0"
            :src="getPreviewUrl(previews[currentIndex].s3key)"
            alt="Fullscreen Preview"
            class="fullscreen-image"
          ></v-img>
          <div class="fullscreen-navigation">
            <v-btn
              class="rounded-lg"
              @click="prevImage"
              :disabled="currentIndex === 0"
              icon="mdi-arrow-left"
            ></v-btn>
            <v-btn
              @click="nextImage"
              class="rounded-lg"
              :disabled="currentIndex === previews.length - 1"
              icon="mdi-arrow-right"
            ></v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import apiClient from "../../plugins/axios";

export default {
  data() {
    return {
      previews: [],
      currentIndex: 0,
      fullscreenDialog: false,
    };
  },
  methods: {
    async fetchPreviews() {
      try {
        const response = await apiClient.get("/getters/getPagesPreviews");
        this.previews = response.data.map((preview) => ({
          ...preview,
          companyName: preview.companyName || "Unknown Company", // Default if companyName is missing
        }));
        this.currentIndex = this.previews.length - 1; // Start with the most recent image
      } catch (error) {
        console.error("Failed to fetch previews:", error);
      }
    },
    openAgencyDialog(preview) {
      this.$store.dispatch("agency/setDialogReturnRoute", this.$route.fullPath);
      this.$router.push({
        name: "agency",
        params: { agencyId: preview.ownerAgency },
      });
    },
    getPreviewUrl(s3key) {
      return `https://d3jzzvbvsu2f3f.cloudfront.net/${s3key}`;
    },
    prevImage() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    nextImage() {
      if (this.currentIndex < this.previews.length - 1) {
        this.currentIndex++;
      }
    },
    openFullscreenDialog() {
      this.fullscreenDialog = true;
    },
  },
  mounted() {
    this.fetchPreviews();
  },
};
</script>

<style scoped>
.gallery-wrapper {
  padding: 16px;
  text-align: center;
  border-radius: 12px;
  background-color: #f9f9f9;
}

.preview-image {
  height: 300px;
  object-fit: cover;
  cursor: pointer;
}

.navigation-buttons {
  margin: 16px 0;
  display: flex;
  justify-content: center;
  gap: 8px;
}

.fullscreen-image {
  height: 80vh;
  object-fit: contain;
}

.fullscreen-navigation {
  margin: 16px 0;
  display: flex;
  justify-content: center;
  gap: 8px;
}
</style>

